<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Bya3Com"
          />
        </div>
      </b-col>
      <b-col
        lg="4"
        class="d-flex flex-column align-items-center justify-content-center auth-bg px-2 px-md-0 p-lg-5"
      >

        <b-link
          class="mb-2"
        >
          <okmenu-logo />
        </b-link>
        <div
          class="d-flex flex-column align-items-center justify-content-center w-100"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1 text-center"
          >
            {{ $t('auth.welcome') }}
          </b-card-title>
          <!--<b-card-text class="mb-2 text-center">
            {{ $t('auth.welcome-hint') }}
          </b-card-text>-->
          <error-alert
            v-if="error"
            class="w-100"
            :error="error"
          />

          <validation-observer
            ref="loginForm"
            tag="div"
            class="w-100"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="username">{{ $t('auth.username') }}</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="username"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="username"
                      v-model="username"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge px-1"
                      dir="ltr"
                      name="username"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        icon="UserIcon"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">{{ $t('auth.password') }}</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="remember"
                  name="checkbox-1"
                >
                  {{ $t('auth.remember-me') }}
                </b-form-checkbox>
              </b-form-group>
              <!-- checkbox -->

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="submitting"
                @click="submit"
              >
                <b-spinner
                  v-if="submitting"
                  small
                  class="mr-50"
                />
                {{ $t('auth.login') }}
              </b-button>
            </b-form>
          </validation-observer>
          <div class="my-2">
            {{ $t('auth.or') }}
          </div>
          <b-button
            class="btn-facebook"
            :disabled="loading"
            block
            @click="authFacebook()"
          >
            <b-spinner
              v-if="loading"
              small
              class="mr-1"
            />
            <feather-icon
              icon="FacebookIcon"
              class="mr-50"
            />
            <span>{{ $t('auth.facebook') }}</span>
          </b-button>
          <!-- form -->
        </div>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import OkmenuLogo from '@core/layouts/components/Logo.vue'
import {
  BLink, BImg, BFormGroup, BRow, BCol, BFormInput, BInputGroupAppend, BInputGroup, BCardTitle, BForm, BButton, BFormCheckbox, BSpinner,
} from 'bootstrap-vue'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { required } from '@validations'
import ErrorAlert from '@/@bya3/components/alerts/ErrorAlert'
import AuthMixin from '@/views/auth/mixins/auth-mixin'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { notifyFlutterAppLoginSuccess, redirectToHomeIfInWebView } from '@/utils/flutter-webview'

export default {
  components: {
    ErrorAlert,
    BRow,
    ValidationProvider,
    ValidationObserver,
    BCol,
    BLink,
    BCardTitle,
    BImg,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BForm,
    BFormCheckbox,

    BButton,
    OkmenuLogo,
    BSpinner,
  },
  mixins: [AuthMixin, togglePasswordVisibility],
  data() {
    return {
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      password: '',
      remember: true,
      username: '',
      required,
      error: null,
      submitting: false,
      status: '',
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (this.$store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    async submit() {
      this.error = null
      const isValid = await this.$refs.loginForm.validate()

      if (!isValid) return

      const credentials = {
        username: this.username,
        password: this.password,
        oneTime: !this.remember,
      }
      this.submitting = true
      this.$store.dispatch('auth/LOGIN', credentials)
        .then(user => {
          if (user) {
            notifyFlutterAppLoginSuccess()
            this.$notifySuccess(this.$t('auth.welcome-back-user', [this.$store.getters['auth/user']?.name ?? '']))
            if (redirectToHomeIfInWebView(this.$router)) return
            this.$router.push({ name: 'owner:home' })
          } else {
            this.error = this.$t('auth.wrong-data')
            this.$notifyError(this.$t('auth.wrong-data'))
          }
        })
        .catch(err => {
          this.$notifyError(err)
          this.error = err
        }).finally(() => {
          this.submitting = false
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
